import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id C721C684-43CC-4B3B-B91A-A574D5215FF3
 * name chevron-up-box
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-up-box.svg
 * tags
 * - Arrow 
 */
export const ChevronUpBoxIcon = createSvgIcon(<><path d="M19,3H5A2,2 0 0,0 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5A2,2 0 0,0 19,3M16.59,15.71L12,11.12L7.41,15.71L6,14.29L12,8.29L18,14.29L16.59,15.71Z" /></>, 'ChevronUpBoxIcon');
export default ChevronUpBoxIcon